/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HeaderModule
 */

import {
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';
import * as l10n from './avi-main-header-user-card.l10n';
import './avi-main-header-user-card.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 *     Component displaying user account information along with a button to edit My Account settings
 *     and a button to generate an SSO token.
 * @author alextsg
 */
@Component({
    selector: 'avi-main-header-user-card',
    templateUrl: './avi-main-header-user-card.component.html',
})
export class AviMainHeaderUserCardComponent {
    @Input()
    public username: string;

    @Input()
    public fullName: string;

    @Input()
    public email: string;

    @Input()
    public lastLogin: string;

    @Output()
    public onOpenMyAccountModal = new EventEmitter<void>();

    @Output()
    public onOpenGenerateTokenDialog = new EventEmitter<void>();

    public readonly l10nKeys = l10nKeys;

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }
}
